import { GET_SERVICE_CENTRES, CLEAR_FORM } from "../actions";

const initialState = {
  centreLocation: null,
  serviceCentres: null,
  serviceCentresFailed: false,
  serviceCentresLoading: false,
  serviceCentresSucceeded: false,
  finished: null,
  step: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'STORE_COLLECTION_OF_LICENCE':
      return {
        ...state,
        ...action.payload
      };
    case 'GET_APPLICATION_FULFILLED':
      return {
        ...action.payload.collectionOfLicence
      };
    case `${GET_SERVICE_CENTRES}_PENDING`:
      return {
        ...state,
        serviceCentresLoading: true,
        serviceCentresFailed: false,
        serviceCentresSucceeded: false,
        serviceCentres: null
      };
    case `${GET_SERVICE_CENTRES}_REJECTED`:
      return {
        ...state,
        serviceCentresLoading: false,
        serviceCentresFailed: true,
        serviceCentresSucceeded: false,
        serviceCentres: null
      };
    case `${GET_SERVICE_CENTRES}_FULFILLED`:
      return {
        ...state,
        serviceCentresLoading: false,
        serviceCentresFailed: false,
        serviceCentresSucceeded: true,
        serviceCentres: action.payload.data

      };
    case CLEAR_FORM:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
